import { render, staticRenderFns } from "./cLandingLinksColoured.vue?vue&type=template&id=6f5a4e52&scoped=true"
import script from "./cLandingLinksColoured.vue?vue&type=script&lang=js"
export * from "./cLandingLinksColoured.vue?vue&type=script&lang=js"
import style0 from "./cLandingLinksColoured.vue?vue&type=style&index=0&id=6f5a4e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a4e52",
  null
  
)

export default component.exports